// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__289Xt","buttons":"RemoveExpirationActionButtons_buttons__1ft-X"};